export default "__VITE_ASSET__Cd99BjZM__"